export default "__VITE_ASSET__B17NKHw$__"